import 'react-international-phone/style.css';
import React from 'react'
import ApiCustomer from '../code/api/ApiCustomer';
import Customer from '../code/models/Customer';
import CustomerStats from '../code/models/CustomerStats';
import CustomerChangeTracker from '../code/helpers/CustomerChangeTracker';
import Api_Config from '../code/api/ApiConfig';
import '../css/customerinfodetail.css';
import AuthAdminUserModel from "../code/models/AuthAdminUserModel";
import Toaster from "./Toaster";

interface ICustomerInfoPilot {
    customer: Customer;
    currentUser: AuthAdminUserModel;
}

export default function CustomerInfoPilot({ customer, currentUser }: ICustomerInfoPilot) {
    const [customerStats, setCustomerStats] = React.useState<CustomerStats | null>(null);
    const [editCustomerStats, setEditCustomerStats] = React.useState<CustomerStats | null>(null);
    const [toastMessage, setToastMessage] = React.useState<string>("");
    const [hasChanges, setHasChanges] = React.useState<boolean>(false);

    React.useEffect(() => {
        loadData();
    }, []);

    function loadData() {
        ApiCustomer.getCustomerStats(customer.customerId).then(data => {
            data = data || new CustomerStats();
            setCustomerStats(data);
            setEditCustomerStats(structuredClone(data));
        });
    }

    function handleUpdateStats() {
        if (checkSaveable()) {
            if (anyChanges() && !!editCustomerStats) {
                ApiCustomer.updateCustomerStats(customer.customerId, editCustomerStats.aircraftGroup || "", editCustomerStats.position || "",
                    editCustomerStats.base || "").then(result => {
                        if (result) {
                            setToastMessage("Fleet, seat, and base have been updated.");
                            loadData();
                        } else {
                            setToastMessage("Update failed.");
                        }
                    });
            }
        } else {
            setToastMessage("You must select a fleet, seat, and base in order to save.");
        }
    }

    function anyChanges(): boolean {
        if (!customerStats || !editCustomerStats) return false;
        return customerStats.position !== editCustomerStats.position ||
            customerStats.base !== editCustomerStats.base ||
            customerStats.aircraftGroup !== editCustomerStats.aircraftGroup;
    }

    function checkSaveable(): boolean {
        if (!customerStats || !editCustomerStats) return false;
        return !!editCustomerStats.position && !!editCustomerStats.base && !!editCustomerStats.aircraftGroup;
    }

    function buildOptions(id: string, vals: string[]) {
        return vals.map((v) => {
            return (<option key={id + v} value={v}>{v}</option>)
        });
    };

    function checkHasChanges() {
        setHasChanges(anyChanges());
    }

    return (
        <React.Fragment>
            <div className="container" aria-readonly={true}>
                <div className="row pad-top-20" key={"fleet" + customerStats?.aircraftGroup}>
                    <div className="col-md-3">
                        <label htmlFor="selectFleet" className="form-label">Fleet</label>
                        <select className="form-select" id="selectFleet" defaultValue={customerStats?.aircraftGroup || ""}
                            onChange={(e) => {
                                if (!!editCustomerStats) {
                                    editCustomerStats.aircraftGroup = e.target.value;
                                    checkHasChanges();
                                }
                            }}>
                            <option value={""}></option>
                            {buildOptions("selectFleet", Api_Config.getSelectedCompany().aircraft)}
                        </select>
                    </div>
                </div>
                <div className="row pad-top-10" key={"seat" + customerStats?.position}>
                    <div className="col-md-3">
                        <label htmlFor="selectSeat" className="form-label">Seat</label>
                        <select className="form-select" id="selectSeat" defaultValue={customerStats?.position || ""}
                            onChange={(e) => {
                                if (!!editCustomerStats) {
                                    editCustomerStats.position = e.target.value;
                                    checkHasChanges();
                                }
                            }}>
                            <option value={""}></option>
                            {buildOptions("selectSeat", Api_Config.getSelectedCompany().positions)}
                        </select>
                    </div>
                </div>
                <div className="row pad-top-10" key={"base" + customerStats?.base}>
                    <div className="col-md-3">
                        <label htmlFor="selectBase" className="form-label">Base</label>
                        <select className="form-select" id="selectBase" defaultValue={customerStats?.base || ""}
                            onChange={(e) => {
                                if (!!editCustomerStats) {
                                    editCustomerStats.base = e.target.value;
                                    checkHasChanges();
                                }
                            }}>
                            <option value={""}></option>
                            {buildOptions("selectBase", Api_Config.getSelectedCompany().bases)}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <button id="updateStatsButton" onClick={handleUpdateStats} disabled={!hasChanges}
                            className={"btn btn-outline-primary pad-top-20"}>Update Pilot Info</button>
                    </div>
                </div>
            </div>
            <Toaster title="Pilot Info" subtitle="Update" message={toastMessage} key={"pilotinfotoast"} />
        </React.Fragment>
    )
}
